var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fb-default-layout',{attrs:{"sidebar-data":_vm.sidebarData,"appInfo":_vm.appInfo},on:{"logout":_vm.handleLogout,"changePassword":function($event){return _vm.$router.push('/update-user-password')},"userCenter":function($event){return _vm.$router.push('/update-user-info')}}},[_c('template',{slot:"footer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }